import { useMemo } from 'react'

import useABTestValue from '@hooks/useABTestValue'

export type Step = 'welcome' | 'app' | 'newsletter' | 'highlights'

export type UseBlickPlusOnboardingStepsABTest = () => Step[] | undefined

const useBlickPlusOnboardingStepsABTest: UseBlickPlusOnboardingStepsABTest =
  () => {
    const onboardingStepsOrder = useABTestValue('onboardingStepsOrder')

    return useMemo(
      () => onboardingStepsOrder?.split(',') ?? [],
      [onboardingStepsOrder]
    ) as Step[]
  }

export default useBlickPlusOnboardingStepsABTest
